import { Switch } from 'antd'
import classNames from 'classnames'
import type { ReactNode } from 'react'

import cn from './AtomToggleSwitch.module.scss'

type AtomToggleSwitchProps = {
  checked: boolean
  onChange: (checked: boolean) => void
  children?: ReactNode
  isOrganisationSelected?: boolean
  disabled?: boolean
  className?: string
}

function AtomToggleSwitch({
  checked,
  onChange,
  children,
  isOrganisationSelected = false,
  disabled = false,
  className,
}: AtomToggleSwitchProps) {
  return (
    <label
      className={classNames(
        cn.toggle,
        isOrganisationSelected && cn.toggleSelected,
        disabled && cn.disabled,
        className
      )}
    >
      {children && <span className={cn.label}>{children}</span>}
      <Switch
        checked={checked}
        disabled={disabled}
        className={cn.switch}
        onChange={(value) => onChange(value)}
      />
    </label>
  )
}

export default AtomToggleSwitch
